import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Divider from '@material-ui/core/Divider'

import { auth } from '../../utils/firebase'

import styles from './ProfilePage.module.css'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    avatar: {
        marginTop: '15px',
        marginBottom: '15px',
        width: '70px',
        height: '70px',
    },
    info: {
        wordBreak: 'break-all'
    }
}))

export default function ProfilePage({ roles, ...props }) {
    const classes = useStyles()

    const currentUser = auth().currentUser

    return (
        <div className={classes.root}>
            <Typography
                variant="h4"
                component="h1"
                className={styles.page__title}
            >
                Профиль пользователя
            </Typography>
            <Divider />

            <Avatar
                className={classes.avatar}
                alt="Аватар пользователя"
                src={currentUser.photoURL}
            />

            <Typography variant="body2" color="textSecondary">
                Имя пользователя
            </Typography>
            <Typography variant="h5" gutterBottom className={classes.info}>
                {currentUser.displayName || 'не указано'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
                Роль
            </Typography>
            <Typography variant="h5" gutterBottom className={classes.info}>
                {currentUser.role || 'не указано'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
                Почта
            </Typography>
            <Typography variant="h5" gutterBottom className={classes.info}>
                {currentUser.email
                    ? `${currentUser.email} (${
                          currentUser.emailVerified
                              ? 'подтверждена'
                              : 'не подтверждена'
                      })`
                    : 'не указано'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
                Номер телефона
            </Typography>
            <Typography variant="h5" gutterBottom className={classes.info}>
                {currentUser.phoneNumber || 'не указано'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
                uid
            </Typography>
            <Typography variant="h5" gutterBottom className={classes.info}>
                {currentUser.uid || 'не указано'}
            </Typography>
        </div>
    )
}
